import { render, staticRenderFns } from "./batchSearch.vue?vue&type=template&id=8f52c442&scoped=true"
import script from "./batchSearch.vue?vue&type=script&lang=js"
export * from "./batchSearch.vue?vue&type=script&lang=js"
import style0 from "./batchSearch.vue?vue&type=style&index=0&id=8f52c442&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f52c442",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f52c442')) {
      api.createRecord('8f52c442', component.options)
    } else {
      api.reload('8f52c442', component.options)
    }
    module.hot.accept("./batchSearch.vue?vue&type=template&id=8f52c442&scoped=true", function () {
      api.rerender('8f52c442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/search/page/batchSearch.vue"
export default component.exports